module.exports = __webpack_public_path__ + "static/media/logo3.107788c6.png";